import Vue from 'vue'
import Vuex from 'vuex'

// Plugins
import pathify from '@/plugins/pathify'
import createPersistedState from '@/plugins/vuex-persistedstate'

Vue.use(Vuex)

// Modules
import app from './modules/app.module'
import auth from './modules/auth.module'
import examen from './modules/examen.module'
import usuario from './modules/usuario.module'

const modules = {
  app,
  auth,
  usuario,
  examen,
}

const actions = {
	/**
   * Reset state by module.
   * @param {Object} context 
   */
  reset({ commit }) {
    commit('app/reset')
    commit('auth/reset')
    commit('usuario/reset')
  }
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',

	plugins: [
		createPersistedState,
		pathify.plugin
  ],

  actions,
  modules,
})
